<div class="container container_type_main">
  <div class="subtitle mt-32 h2">{{ 'privacy-page.title' | translate }}</div>
  <div class="paragraph" [innerHtml]="'privacy-page.text' | translate"></div>
</div>
